// extracted by mini-css-extract-plugin
export default {"gateTitle":"Gate_gateTitle__fNePD","systemGateHeader":"Gate_systemGateHeader__QN5NN"};